import React, { useState } from 'react';
import connect from 'react-redux/lib/connect/connect';
import { isEmpty, isMobilePage } from '../../common/cores';
import Pagenation from '../common/Pagenation';

const RecommenderContent = (props) => {

    const [showHis, setShowHis] = useState(false);

    const showHisotry = () => {
        setShowHis(!showHis);
    }

    const { user, page } = props;

    const getLists = () => {}
    return (
        <div data-v-394b74b4="" className="scrollable-auto column" style= {{ width: "100%" }}>
    <div data-v-f0cbefaa="" data-v-394b74b4="" className="recommend row" style= {{ flexDirection: "row" }}>
        { isMobilePage() &&
                <div data-v-f0cbefaa="" className="mobile-tab row" style={{flexDirection: "row"}}>
                <div data-v-f0cbefaa="" className="column">
                    <button data-v-f0cbefaa="" className={`button ${ !showHis && "active"}`} onClick={showHisotry}>
                        <span data-v-f0cbefaa="" className="text">상세정보</span>
                    </button>
                </div>
                <div data-v-f0cbefaa="" className="column">
                    <button data-v-f0cbefaa="" className={`button ${ showHis && "active"}`} onClick={showHisotry}>
                        <span data-v-f0cbefaa="" className="text">추천회원 리스트</span>
                    </button>
                </div>
            </div>
                }
        <div data-v-f0cbefaa="" className="recommend-info scrollable-auto column" style={{display: (isMobilePage() && showHis) && "none"}}>
            <div data-v-f0cbefaa="" className="recommend-wrap column">
                <div data-v-f0cbefaa="" className="title row" style= {{ flexDirection: "row" }}><span data-v-f0cbefaa=""
                        className="text">추천인 상세정보</span></div>
                <div data-v-f0cbefaa="" className="recommend-form column">
                    <div data-v-f0cbefaa="" className="recommend-form-in row" style= {{ flexDirection: "row" }}>
                        <div data-v-f0cbefaa="" className="row" style= {{ flexDirection: "row" }}><span data-v-f0cbefaa=""
                                className="text">추천 가능여부</span></div>
                        <div data-v-f0cbefaa="" className="row" style= {{ flexDirection: "row" }}><span data-v-f0cbefaa=""
                                className="text" style= {{ color: "rgb(255, 108, 108)" }} >불가능</span></div>
                    </div>
                    <div data-v-f0cbefaa="" className="recommend-form-in row" style= {{ flexDirection: "row" }}>
                        <div data-v-f0cbefaa="" className="row" style= {{ flexDirection: "row" }}><span data-v-f0cbefaa=""
                                className="text">추천코드</span></div>
                        <div data-v-f0cbefaa="" className="row" style= {{ flexDirection: "row" }}><span data-v-f0cbefaa=""
                                className="text">{ !isEmpty(user) && user.code}</span></div>
                    </div>
                    <div data-v-f0cbefaa="" className="recommend-form-in row" style= {{ flexDirection: "row" }}>
                        <div data-v-f0cbefaa="" className="row" style= {{ flexDirection: "row" }}><span data-v-f0cbefaa=""
                                className="text">총 추천인 수</span></div>
                        <div data-v-f0cbefaa="" className="row" style= {{ flexDirection: "row" }}><span data-v-f0cbefaa=""
                                className="text">0</span></div>
                    </div>
                    <div data-v-f0cbefaa="" className="recommend-form-in row" style= {{ flexDirection: "row" }}>
                        <div data-v-f0cbefaa="" className="row" style= {{ flexDirection: "row" }}><span data-v-f0cbefaa=""
                                className="text">정상회원</span></div>
                        <div data-v-f0cbefaa="" className="row" style= {{ flexDirection: "row" }}><span data-v-f0cbefaa=""
                                className="text">0</span></div>
                    </div>
                    <div data-v-f0cbefaa="" className="recommend-form-in row" style= {{ flexDirection: "row" }}>
                        <div data-v-f0cbefaa="" className="row" style= {{ flexDirection: "row" }}><span data-v-f0cbefaa=""
                                className="text">탈퇴회원</span></div>
                        <div data-v-f0cbefaa="" className="row" style= {{ flexDirection: "row" }}><span data-v-f0cbefaa=""
                                className="text">0</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div data-v-f0cbefaa="" className="recommend-history scrollable-auto column" style={{display: (isMobilePage() && !showHis) && "none"}}>
            <div data-v-f0cbefaa="" className="recommend-history-in column">
                <div data-v-f0cbefaa="" className="title row" style= {{ flexDirection: "row" }}><span data-v-f0cbefaa=""
                        className="text">추천회원 리스트</span></div>
                <div data-v-f0cbefaa="" className="history column">
                    <table data-v-f0cbefaa="">
                        <thead data-v-f0cbefaa="">
                            <tr data-v-f0cbefaa="">
                                <th data-v-f0cbefaa="">번호</th>
                                <th data-v-f0cbefaa="">가입일시</th>
                                <th data-v-f0cbefaa="">아이디</th>
                                <th data-v-f0cbefaa="">닉네임</th>
                                <th data-v-f0cbefaa="">접속횟수</th>
                            </tr>
                        </thead>
                        <tbody data-v-f0cbefaa="">
                            <tr>
                                <td data-v-f0cbefaa="" colSpan="5" className="no-data"><span data-v-f0cbefaa="" className="text"
                                        style= {{ justifyContent: "center" }}>
                                        데이터가 없습니다
                                    </span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div data-v-f0cbefaa="" className="bottom row" style= {{ flexDirection: "row" }}>
                    <div data-v-f0cbefaa="" className="spacer"></div> <span data-v-f0cbefaa="" className="text">총 추천회원 {0}명
                        <span data-v-f0cbefaa="" className="margin-left-5 text"
                            style= {{ color: "rgb(246, 195, 58)" }} >0</span></span>
                </div>
            </div>
            <div data-v-216d8a58="" className="pagination-out column">
                <div data-v-3badc2f2="" data-v-216d8a58="" className="pagination row"
                    style={{ flexDirection: "row", alignItems: "center" }}>
                    <div style={{ margin: "0px auto", width: "100%", paddingLeft: "10px" }}>
                        <Pagenation page={page.curPage}
                            totalPage={page.totalPage}
                            getPage={getLists} 
                            perPage={10}/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
    )

}

const mapStateToProps = state => ({
    user: state.user.data,
    page: state.page,
})

export default connect(mapStateToProps, {})(RecommenderContent);


// WEBPACK FOOTER //
// ./src/components/account/RecommenderContent.js